import { render } from "./VerifyEmailRequest.vue?vue&type=template&id=2efdec0f"
import script from "./VerifyEmailRequest.vue?vue&type=script&lang=js"
export * from "./VerifyEmailRequest.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/cafedenj-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__